import React, { useContext } from 'react'
import { GlobalDataContext } from '../../../context/context';
import { Link } from 'react-router-dom';

const PrimaryButton = ({ BgColorWhite, url, text, direction, urlPhone, btnUrlTel, btnphone }) => {
    const { rpdata } = useContext(GlobalDataContext);
    const goToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };
    return (
        <div>
            {rpdata?.simpleWidgets?.[3]?.activo ? null : (
                <>
                    {urlPhone ? (
                        <div
                            className={`lg:w-1/2 w-full flex flex-col items-center md:items-start text-center lg:text-start`}
                        >
                            <a
                                className={`w-[220px] h-auto  px-12 py-4 ${direction ? "rounded-l-full" : "rounded-r-full"}  ${BgColorWhite
                                    ? "bg-gradient-to-l from-white text-primary transition ease-in-out delay-200 hover:translate-x-5 duration-300"
                                    : direction ?
                                        "bg-gradient-to-r from-btn to-slate-200/60 transition ease-in-out delay-200 hover:-translate-x-5 duration-300" : 'bg-gradient-to-l from-btn to-white/40 transition ease-in-out delay-200 hover:translate-x-5 duration-300'
                                    } `}
                                    href={btnUrlTel ? btnUrlTel : `tel:+1${btnphone}`}
                                onClick={goToTop}

                            >
                                <span className={`font-bold pl-5 ${BgColorWhite ? "text-primary" : "text-white"}`}>
                                    {text ? text : "Free Estimate"}
                                </span>
                            </a>
                        </div>
                    ) : (
                        <div
                            className={`lg:w-1/2 w-full flex flex-col items-center md:items-start text-center lg:text-start`}
                        >
                            <Link
                                className={`w-[220px] h-auto  px-12 py-4 ${direction ? "rounded-l-full" : "rounded-r-full"}  ${BgColorWhite
                                    ? "bg-gradient-to-l from-white text-primary transition ease-in-out delay-200 hover:translate-x-5 duration-300"
                                    : direction ?
                                        "bg-gradient-to-r from-btn to-white/40 transition ease-in-out delay-200 hover:-translate-x-5 duration-300" : 'bg-gradient-to-l from-btn to-white/40 transition ease-in-out delay-200 hover:translate-x-5 duration-300'
                                    } `}
                                to={url ? url : "/contact"}
                                onClick={goToTop}

                            >
                                <span className={`font-bold pl-5 ${BgColorWhite ? "text-primary" : "text-white"}`}>
                                    {text ? text : "Free Estimate"}
                                </span>
                            </Link>
                        </div>)}
                </>
            )}
        </div>
    )
}
export default PrimaryButton;
